if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.querySelector('[name=id]').disabled = false;
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
      this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      this.submitButton = this.querySelector('[type="submit"]');
      if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

      this.handleErrorMessage();

      this.submitButton.setAttribute('aria-disabled', true);
      this.submitButton.classList.add('loading');
      this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];

      const formData = new FormData(this.form);
      if (this.cart) {
        formData.append('sections', this.cart.getSectionsToRender().map((section) => section.id));
        formData.append('sections_url', window.location.pathname);
        this.cart.setActiveElement(document.activeElement);
      }
      config.body = formData;

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);

            const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
            if (!soldOutMessage) return;
            this.submitButton.setAttribute('aria-disabled', true);
            this.submitButton.querySelector('span').classList.add('hidden');
            soldOutMessage.classList.remove('hidden');
            this.error = true;
            return;
          } else if (!this.cart) {
            window.location = window.routes.cart_url;
            return;
          }

          if (!this.error) publish(PUB_SUB_EVENTS.cartUpdate, {source: 'product-form'});
          this.error = false;
          const quickAddModal = this.closest('quick-add-modal');
          if (quickAddModal) {
            document.body.addEventListener('modalClosed', () => {
              setTimeout(() => { this.cart.renderContents(response) });
            }, { once: true });
            quickAddModal.hide(true);
          } else {
            this.cart.renderContents(response);
          }
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.submitButton.classList.remove('loading');
          if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          if (!this.error) this.submitButton.removeAttribute('aria-disabled');
          this.querySelector('.loading-overlay__spinner').classList.add('hidden');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      if (!this.errorMessageWrapper) return;
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });
}

/* UploadKit UpCart integration */
window.upcartShouldAddToCartContinue = function() {
  if(document.querySelector(".uploadkit-invalid")) { return false }
  return true
}

window.UploadKit = window.UploadKit || {};
window.UploadKit.scanAttributes = function () {
  var regex = new RegExp(
    "https:\\/\\/cdn2?\\.shopify\\.com(?:-?uploadkit\\.(?:app|com))?\\/.*\\?.*id=[^&]*&uu=([^&]*)&mo=([^&]*)&fi=([^&]*)(?:(?!&image).)*(&image=true)?",
    "g"
  );

  function acceptNode() {
    return NodeFilter.FILTER_ACCEPT;
  }

  function replaceUploadKitLinks(match, uuid, modifiers, filename, isImage) {
    if (isImage) {
      return (
        '<a href="https://cdn.getuploadkit.com/' +
        uuid +
        "/" +
        modifiers +
        '-/preview/1200x1200" class="uploadkit-preview-link-image" title="' +
        atob(filename) +
        '"><img src="https://cdn.getuploadkit.com/' +
        uuid +
        "/" +
        modifiers +
        '-/resize/300x/" style="max-width: 50px; max-height: 50px; vertical-align: middle;" /></a>'
      );
    } else {
      return (
        '<a href="https://cdn.getuploadkit.com/' +
        uuid +
        "/" +
        '" class="uploadkit-preview-link" target="_blank">' +
        atob(filename) +
        "</a>"
      );
    }
  }

  function traverseNodes(root) {
    var filter = acceptNode;
    filter.acceptNode = acceptNode;

    var treeWalker = document.createTreeWalker(root, NodeFilter.SHOW_ALL, filter, false);
    var foundNodes = [];

    while (treeWalker.nextNode()) {
      var node = treeWalker.currentNode;
      regex.lastIndex = 0;

      if (node.nodeType === 3 && regex.exec(node.textContent)) {
        foundNodes.push(node);
      }

      if (window.UploadKit.config && window.UploadKit.config.uploaders) {
        if (node.nodeType === 3 && node.textContent.indexOf("_") > -1) {
          for (var i = 0; i < window.UploadKit.config.uploaders.length; i++) {
            node.textContent = node.textContent.replace(
              "_" + window.UploadKit.config.uploaders[i].name,
              window.UploadKit.config.uploaders[i].name
            );
          }
        }
      }

      if (node.nodeType === 1 && node.shadowRoot) {
        foundNodes = foundNodes.concat(traverseNodes(node.shadowRoot));
      }
    }

    return foundNodes;
  }

  // Function to inject a stylesheet into the shadow root of the element with id "upCart"
  function injectStylesheetToShadowRoot() {
      // Find the element with the id "upCart"
      const upCartElement = document.getElementById("upCart");
  
      // Check if the element exists and has a shadow root
      if (upCartElement && upCartElement.shadowRoot) {
          const shadowRoot = upCartElement.shadowRoot;
  
          // Check if a <style> tag already exists in the shadow root
          let styleTag = shadowRoot.querySelector("style[data-uploadkit-upcart='true']");
  
          if (!styleTag) {
              // If the <style> tag does not exist, create one
              styleTag = document.createElement("style");
              styleTag.setAttribute("data-uploadkit-upcart", "true");
              styleTag.textContent = `
                  .upcart-item-properties { opacity: 1 !important; }
                  .lum-lightbox { z-index: 2147483647; }
              `;
  
              // Append the <style> tag to the shadow root
              shadowRoot.appendChild(styleTag);
              console.log("Stylesheet injected into shadow root.");
          } else {
              console.log("Stylesheet already exists in the shadow root.");
          }
      } else {
          console.warn("Element with id 'upCart' does not exist or does not have a shadow root.");
      }
  }
  

  function collectPreviewLinks(root) {
    let links = [];
  
    // Helper function to traverse nodes, including shadow roots
    function traverse(node) {
      if (node.nodeType === 1) { // Element node
        if (node.matches("a.uploadkit-preview-link-image")) {
          links.push(node); // Add matching link
        }
        // If the node has a shadow root, traverse its contents
        if (node.shadowRoot) {
          traverse(node.shadowRoot);
        }
      }
      // Traverse child nodes of the current node
      node.childNodes.forEach((child) => traverse(child));
    }
  
    // Start traversal from the root
    traverse(root);
    return links;
  }

  var allFoundNodes = traverseNodes(document.body);

  for (var i = 0; i < allFoundNodes.length; i++) {
    var node = allFoundNodes[i];
    regex.lastIndex = 0;
    var match = regex.exec(node.textContent);
    if (match) {
      var replacementNode = document.createElement("span");
      replacementNode.innerHTML = node.textContent.replace(
        regex,
        replaceUploadKitLinks
      );
      node.parentNode.insertBefore(replacementNode, node);
      node.parentNode.removeChild(node);
    }
  }

  if (allFoundNodes.length > 0) {
    var lightboxStyles = document.createElement("link");
    lightboxStyles.type = "text/css";
    lightboxStyles.rel = "stylesheet";
    lightboxStyles.href = "https://assets.getuploadkit.com/assets/luminous.css";
    document.head.appendChild(lightboxStyles);

    var lightboxScript = document.createElement("script");
    lightboxScript.type = "text/javascript";
    lightboxScript.async = true;
    lightboxScript.src = "https://assets.getuploadkit.com/assets/luminous.js";
    document.head.appendChild(lightboxScript);

    lightboxScript.onload = function () {
      // Collect all preview links from main document and shadow roots
      var previewLinks = collectPreviewLinks(document.body);
      console.log("previewLinks", previewLinks)
      new LuminousGallery(previewLinks);
      injectStylesheetToShadowRoot();
    };
  }
};